import {useEffect} from 'react';

import {useInitialization} from '../../../hooks';
import {getObjectValues} from '../../../utils';

function useSearchActions(data) {
    const {
        searchEvents: {
            onCurrentValuesChange,
            onLatestValuesChange
        },
        initialSearchValues,
        currentSearchValues,
        latestSearchValues,
        setAllSearchValuesInitial
    } = data;

    const {
        isInitialized
    } = useInitialization();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setAllSearchValuesInitial, [...getObjectValues(initialSearchValues)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerCurrentSearchValuesChange() {
        if (isInitialized) {
            onCurrentValuesChange(currentSearchValues);
        }
    }, [...getObjectValues(currentSearchValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerLatestSearchValuesChange() {
        if (isInitialized) {
            onLatestValuesChange(latestSearchValues);
        }
    }, [...getObjectValues(latestSearchValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */
}

export {useSearchActions};
